// extracted by mini-css-extract-plugin
export default {"tooltip":"Zn-z","sharingV2":"_n-z","sharingIconsV2":"ao-z","links":"bo-z","link":"co-z","facebookV2":"do-z","twitterV2":"eo-z","pinterestV2":"fo-z"};